"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToasterContext = exports.ToasterContextProvider = exports.Toaster = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_1 = __importDefault(require("@emotion/styled"));
const Toast_1 = require("./Toast");
const ToasterContextProvider_1 = require("./ToasterContextProvider");
Object.defineProperty(exports, "ToasterContextProvider", { enumerable: true, get: function () { return ToasterContextProvider_1.ToasterContextProvider; } });
Object.defineProperty(exports, "useToasterContext", { enumerable: true, get: function () { return ToasterContextProvider_1.useToasterContext; } });
const constants_1 = require("../../constants");
const ToasterElement = styled_1.default.div({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gridGap: 16,
    position: 'fixed',
    top: 16,
    left: 0,
    right: 0,
    padding: 16,
    pointerEvents: 'none',
    zIndex: constants_1.theme.zIndex.toast,
});
const Toaster = () => {
    const { removeToast, toasts } = (0, ToasterContextProvider_1.useToasterContext)();
    if (!toasts.length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ToasterElement, { children: toasts.map((toast) => ((0, react_1.createElement)(Toast_1.Toast, { ...toast, key: toast.id, onClose: () => removeToast(toast.id) }))) }));
};
exports.Toaster = Toaster;
